(function () {
  'use strict';

  var pendingButtons = [];
  var gokwikCloseBound = false;

  function isMaternityPage() {
    return document.body.classList.contains('frido-maternity-pillow-plus-page');
  }

  function isTravelNeckPillowPage() {
    return document.body.classList.contains('frido-travel-neck-pillow-page');
  }

  function isFiveToeSocksPage() {
    return document.body.classList.contains('frido-five-toe-socks-page');
  }

  function isNasalStripsProPage() {
    return document.body.classList.contains('frido-nasal-strips-fitness-page');
  }

  function isToeSeparatorPage() {
    return document.body.classList.contains('frido-toe-separator-page');
  }

  function isPdpGokwikPage() {
    return (
      isMaternityPage() ||
      isTravelNeckPillowPage() ||
      isFiveToeSocksPage() ||
      isNasalStripsProPage() ||
      isToeSeparatorPage()
    );
  }

  function canUseGokwik() {
    return typeof window.onCheckoutClick === 'function';
  }

  function shouldUseGokwik() {
    return isPdpGokwikPage() && canUseGokwik();
  }

  function getTriggerButton() {
    return document.querySelector('[data-frido-pdp-gokwik-trigger] .checkout');
  }

  function applyDiscountCode(code) {
    if (!code) return Promise.resolve();
    var url = '/discount/' + encodeURIComponent(code);
    return fetch(url, {
      method: 'GET',
      credentials: 'same-origin',
      redirect: 'manual',
    }).catch(function () {
      return fetch(url, { credentials: 'same-origin' });
    });
  }

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (res) {
      return res.json();
    });
  }

  function cartHasActiveDiscount(cart) {
    if (!cart) return false;
    if (cart.discount_codes && cart.discount_codes.length) {
      for (var i = 0; i < cart.discount_codes.length; i++) {
        var entry = cart.discount_codes[i];
        if (entry && entry.code) return true;
      }
    }
    if (cart.cart_level_discount_applications && cart.cart_level_discount_applications.length) {
      return true;
    }
    return false;
  }

  function clearCartItems() {
    return fetch('/cart/clear.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    }).then(function (res) {
      if (!res.ok) throw new Error('cart clear failed');
      return res.json();
    });
  }

  function clearCartDiscounts() {
    return fetchCart().then(function (cart) {
      if (!cartHasActiveDiscount(cart)) return cart;

      return fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({ discount: '' }),
      })
        .catch(function () {
          return null;
        })
        .then(function () {
          return fetchCart();
        })
        .then(function (updatedCart) {
          if (!cartHasActiveDiscount(updatedCart)) return updatedCart;

          return fetch('/cart/update.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
              Accept: 'application/json',
            },
            body: 'discount=',
          })
            .catch(function () {
              return null;
            })
            .then(function () {
              return fetchCart();
            });
        });
    });
  }

  function resetCartSession() {
    return clearCartItems()
      .catch(function () {
        return null;
      })
      .then(function () {
        return clearCartDiscounts();
      })
      .catch(function () {
        return null;
      });
  }

  function waitForCartItems(expectedCount, attempts) {
    expectedCount = expectedCount || 1;
    attempts = attempts == null ? 12 : attempts;

    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        if ((cart.item_count || 0) >= expectedCount) return cart;
        if (attempts <= 0) throw new Error('cart timeout');
        return new Promise(function (resolve) {
          setTimeout(resolve, 50);
        }).then(function () {
          return waitForCartItems(expectedCount, attempts - 1);
        });
      });
  }

  function setUIButtonLoading(btn, loading) {
    if (!btn) return;
    if (loading) {
      btn.disabled = true;
      btn.classList.add('is-loading');
      btn.setAttribute('aria-busy', 'true');
      return;
    }
    btn.classList.remove('is-loading');
    btn.removeAttribute('aria-busy');
    btn.disabled = false;
  }

  function releaseUIButton(btn, restoreFn) {
    if (!btn) return;
    setUIButtonLoading(btn, false);
    if (restoreFn) {
      try {
        restoreFn();
      } catch (e) {
        /* noop */
      }
    }
  }

  function registerPendingButton(btn, restoreFn) {
    if (!btn) return;
    pendingButtons = pendingButtons.filter(function (entry) {
      return entry.btn !== btn;
    });
    pendingButtons.push({ btn: btn, restore: restoreFn });
  }

  function removePendingButton(btn) {
    if (!btn) return;
    pendingButtons = pendingButtons.filter(function (entry) {
      return entry.btn !== btn;
    });
  }

  function clearPendingButtons() {
    pendingButtons.slice().forEach(function (entry) {
      releaseUIButton(entry.btn, entry.restore);
    });
    pendingButtons = [];
    document.dispatchEvent(new CustomEvent('frido:pdp-gokwik-checkout-closed'));
  }

  function bindGokwikCloseHandler() {
    if (gokwikCloseBound) return;
    gokwikCloseBound = true;

    function attachSdkListener() {
      if (!window.gokwikSdk || typeof window.gokwikSdk.on !== 'function') return;
      window.gokwikSdk.on('modal_closed', function () {
        if (!isPdpGokwikPage()) return;
        clearPendingButtons();
      });
    }

    if (window.gokwikSdk) attachSdkListener();
    window.addEventListener('gokwikLoaded', attachSdkListener);

    window.addEventListener('pageshow', function () {
      if (!isPdpGokwikPage() || !pendingButtons.length) return;
      clearPendingButtons();
    });

    document.addEventListener('visibilitychange', function () {
      if (!isPdpGokwikPage() || document.visibilityState !== 'visible' || !pendingButtons.length) {
        return;
      }
      clearPendingButtons();
    });
  }

  bindGokwikCloseHandler();

  function aggregateLineItems(lineItems) {
    var counts = {};
    var order = [];
    lineItems.forEach(function (item) {
      var id = String(item.id);
      var qty = parseInt(item.qty, 10) || 1;
      counts[id] = (counts[id] || 0) + qty;
      if (order.indexOf(id) === -1) order.push(id);
    });
    return order.map(function (id) {
      return { id: parseInt(id, 10), qty: counts[id] };
    });
  }

  function buildCartUrl(options) {
    var aggregated = aggregateLineItems(options.lineItems || []);
    var parts = aggregated.map(function (item) {
      return item.id + ':' + item.qty;
    });
    var qs = [
      'rfname=' + encodeURIComponent(options.rfname || 'Frido'),
      'tt-cart-mod=true',
    ];
    if (options.disam != null && options.disam !== '') {
      qs.push('disam=' + options.disam);
    }
    if (options.discountCode) {
      qs.push('discount=' + encodeURIComponent(options.discountCode));
    }
    return '/cart/' + parts.join(',') + '?' + qs.join('&');
  }

  function buildTravelPackCartPayload(options) {
    var rawItems = [];
    var totalIndividual = 0;

    if (options.lineItems && options.lineItems.length) {
      options.lineItems.forEach(function (item) {
        var variantId = parseInt(item.variantId, 10);
        var unitCents = parseInt(item.unitCents, 10) || 0;
        if (!variantId) return;
        rawItems.push({ id: variantId, qty: 1 });
        totalIndividual += unitCents;
      });
    } else {
      var adultVariantId = parseInt(options.adultVariantId, 10);
      var adultQty = parseInt(options.adultQty, 10) || 0;
      var kidsVariantId = parseInt(options.kidsVariantId, 10);
      var kidsQty = parseInt(options.kidsQty, 10) || 0;

      if (adultVariantId && adultQty > 0) {
        rawItems.push({ id: adultVariantId, qty: adultQty });
        totalIndividual += (parseInt(options.adultUnitCents, 10) || 0) * adultQty;
      }
      if (kidsVariantId && kidsQty > 0) {
        rawItems.push({ id: kidsVariantId, qty: kidsQty });
        totalIndividual += (parseInt(options.kidsUnitCents, 10) || 0) * kidsQty;
      }
    }

    var lineItems = aggregateLineItems(rawItems);
    var expectedCount = lineItems.reduce(function (sum, item) {
      return sum + item.qty;
    }, 0);
    var packSale = parseInt(options.saleCents, 10) || 0;
    var disam = totalIndividual - packSale;
    if (disam < 0) disam = 0;

    return {
      lineItems: lineItems,
      expectedCount: expectedCount,
      disam: disam,
    };
  }

  function loadCartFromUrl(cartUrl, expectedCount) {
    return fetch(cartUrl, {
      method: 'GET',
      credentials: 'same-origin',
      redirect: 'manual',
    })
      .then(function (res) {
        if (!(res.type === 'opaqueredirect' || res.status === 0 || res.status === 302 || res.ok)) {
          throw new Error('cart prepare failed');
        }
        return waitForCartItems(expectedCount);
      })
      .catch(function () {
        return fetch(cartUrl, {
          method: 'GET',
          credentials: 'same-origin',
        }).then(function () {
          return waitForCartItems(expectedCount);
        });
      });
  }

  function prepareCartAndCheckout(options) {
    var gokwikBtn = getTriggerButton();

    if (!canUseGokwik() || !gokwikBtn) {
      window.location.href = options.fallbackUrl;
      return Promise.resolve();
    }

    registerPendingButton(options.uiButton, options.onRestore);
    setUIButtonLoading(options.uiButton, true);

    return resetCartSession()
      .then(function () {
        return loadCartFromUrl(options.cartUrl, options.expectedCount || 1);
      })
      .then(function () {
        if (options.discountCode) {
          return applyDiscountCode(options.discountCode);
        }
        return clearCartDiscounts();
      })
      .then(function () {
        window.onCheckoutClick(gokwikBtn);
        releaseUIButton(options.uiButton, options.onRestore);
        removePendingButton(options.uiButton);
        if (options.onComplete) options.onComplete();
      })
      .catch(function () {
        alert('Could not prepare checkout. Please try again.');
        releaseUIButton(options.uiButton, options.onRestore);
        removePendingButton(options.uiButton);
        if (options.onError) options.onError();
      });
  }

  function checkoutVariant(variantId, qty, uiButton, opts) {
    opts = opts || {};
    var q = parseInt(qty, 10) || 1;
    var cartUrl = buildCartUrl({
      lineItems: [{ id: variantId, qty: q }],
      rfname: opts.rfname,
      discountCode: opts.discountCode,
    });
    var fallbackUrl = 'https://myfrido.com/cart/' + variantId + ':' + q;
    if (opts.discountCode) {
      fallbackUrl += '?rfname=Frido&tt-cart-mod=true&discount=' + encodeURIComponent(opts.discountCode);
    } else {
      fallbackUrl += '?rfname=Frido&tt-cart-mod=true';
    }

    if (!shouldUseGokwik()) {
      window.location.href = fallbackUrl;
      return;
    }

    prepareCartAndCheckout({
      cartUrl: cartUrl,
      uiButton: uiButton,
      expectedCount: 1,
      discountCode: opts.discountCode,
      fallbackUrl: fallbackUrl,
      onComplete: opts.onComplete,
      onError: opts.onError,
      onRestore: opts.onRestore,
    });
  }

  function checkoutTravelPack(travelOptions, uiButton, opts) {
    opts = opts || {};
    var payload = buildTravelPackCartPayload(travelOptions);
    if (!payload.lineItems.length) {
      if (opts.onError) opts.onError();
      return;
    }

    var cartUrl = buildCartUrl({
      lineItems: payload.lineItems,
      rfname: travelOptions.rfname,
      discountCode: travelOptions.discountCode,
      disam: payload.disam,
    });
    var parts = payload.lineItems.map(function (item) {
      return item.id + ':' + item.qty;
    });
    var fallbackUrl = 'https://myfrido.com/cart/' + parts.join(',') + '?rfname=Frido&tt-cart-mod=true';
    if (payload.disam > 0) {
      fallbackUrl += '&disam=' + payload.disam;
    }
    if (travelOptions.discountCode) {
      fallbackUrl += '&discount=' + encodeURIComponent(travelOptions.discountCode);
    }

    if (!shouldUseGokwik()) {
      window.location.href = fallbackUrl;
      return;
    }

    prepareCartAndCheckout({
      cartUrl: cartUrl,
      uiButton: uiButton,
      expectedCount: payload.expectedCount,
      discountCode: travelOptions.discountCode,
      fallbackUrl: fallbackUrl,
      onComplete: opts.onComplete,
      onError: opts.onError,
      onRestore: opts.onRestore,
    });
  }

  function checkoutBundle(baseVariantId, extraVariantId, uiButton, opts) {
    opts = opts || {};
    var cartUrl = buildCartUrl({
      lineItems: [
        { id: baseVariantId, qty: 1 },
        { id: extraVariantId, qty: 1 },
      ],
      rfname: opts.rfname || 'Frido',
      discountCode: opts.discountCode,
    });
    var fallbackUrl =
      'https://myfrido.com/cart/' +
      baseVariantId +
      ':1,' +
      extraVariantId +
      ':1?rfname=Frido&tt-cart-mod=true';
    if (opts.discountCode) {
      fallbackUrl += '&discount=' + encodeURIComponent(opts.discountCode);
    }

    if (!shouldUseGokwik()) {
      window.location.href = fallbackUrl;
      return;
    }

    prepareCartAndCheckout({
      cartUrl: cartUrl,
      uiButton: uiButton,
      expectedCount: 2,
      discountCode: opts.discountCode,
      fallbackUrl: fallbackUrl,
      onComplete: opts.onComplete,
      onError: opts.onError,
      onRestore: opts.onRestore,
    });
  }

  function checkoutFromCart(options) {
    options = options || {};
    var gokwikBtn = getTriggerButton();

    if (!canUseGokwik() || !gokwikBtn) {
      window.location.href = options.fallbackUrl || '/checkout';
      return Promise.resolve();
    }

    registerPendingButton(options.uiButton, options.onRestore);
    setUIButtonLoading(options.uiButton, true);

    return fetchCart()
      .then(function (cart) {
        if (!cart || !cart.item_count) throw new Error('empty cart');
        var discountPromise = options.discountCode
          ? applyDiscountCode(options.discountCode)
          : clearCartDiscounts();
        return discountPromise.then(function () {
          return cart;
        });
      })
      .then(function () {
        window.onCheckoutClick(gokwikBtn);
        releaseUIButton(options.uiButton, options.onRestore);
        removePendingButton(options.uiButton);
        if (options.onComplete) options.onComplete();
      })
      .catch(function () {
        alert('Could not start checkout. Please try again.');
        releaseUIButton(options.uiButton, options.onRestore);
        removePendingButton(options.uiButton);
        if (options.onError) options.onError();
      });
  }

  window.FridoPdpGokwikCheckout = {
    isMaternityPage: isMaternityPage,
    isTravelNeckPillowPage: isTravelNeckPillowPage,
    isFiveToeSocksPage: isFiveToeSocksPage,
    isPdpGokwikPage: isPdpGokwikPage,
    shouldUseGokwik: shouldUseGokwik,
    checkoutVariant: checkoutVariant,
    checkoutTravelPack: checkoutTravelPack,
    checkoutBundle: checkoutBundle,
    prepareCartAndCheckout: prepareCartAndCheckout,
    checkoutFromCart: checkoutFromCart,
    buildCartUrl: buildCartUrl,
    resetCartSession: resetCartSession,
    clearCartDiscounts: clearCartDiscounts,
    clearPendingButtons: clearPendingButtons,
    fetchCart: fetchCart,
  };
})();
